export const LoomTouchpointVariant = {
	NONE: 'none', // user has turned off product suggestions, or dismissed the ad
	CROSSFLOW: 'cross-flow', // tenant does not have Loom product
	CROSSJOIN: 'cross-join', // user does not have a license to Loom on the tenant
	COUSE: 'co-use', // tenant has Loom and user has a Loom license
} as const;

export type LoomTouchpointVariantType =
	(typeof LoomTouchpointVariant)[keyof typeof LoomTouchpointVariant];
